/* eslint-disable vue/require-v-for-key */
<template>
  <div id="lista-cidades" class="lista-dicas">
    <h1 class="title text-uppercase font-weight-bold">Lista Banners</h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Imagem</th>
          <th>Criado em.</th>
          <!-- <th>Atualizado em.</th> -->
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(banner, index) in banners" :key="index">
          <td>
            <img
              :src="`${getImagesAddress}` + banner.image"
              alt="Imagem do banner"
              class="obj max-obj-contain"
            />
          </td>
          <td>{{ banner.createdAt }}</td>
          <!-- <td>{{ banner.atualizado_em }}</td> -->
          <td
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <b-button
              variant="primary"
              class="mb-1"
              @click="editBanner(banner.id)"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <!-- <b-button class="my-1" variant="warning" @click="seeBanner(banner.id)">
              <i class="fas fa-eye"></i>
            </b-button> -->
            <b-button variant="danger" @click="excluirBanner(banner.id)">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'ListBanners',
  mixins: [makeToast],
  data() {
    return {
      banners: [],
    };
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.getBanners();
  },
  methods: {
    ...mapActions('banner', ['listBanners']),
    ...mapActions('banner', ['deleteBanner']),
    getBanners() {
      this.listBanners()
        .then((response) => {
          this.banners = response.data.banners;
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    editBanner(id) {
      this.$router.push({
        name: 'administrador-edita-banners',
        params: { bannerId: id },
      });
    },
    seeBanner(id) {
      this.$router.push({
        name: 'administrador-ver-banner',
        params: { id },
      });
    },
    async excluirBanner(id) {
      if (window.confirm('Deseja deletar realmente esse banner?')) {
        this.$store.dispatch('startLoader');

        this.deleteBanner(id)
          .then(() => {
            this.makeToast('Sucesso!', 'Deletado com sucesso', 'success');

            this.getBanners();
          })
          .catch(() => {
            this.makeToast(
              'Oopss!',
              'Houve um problema para deletar, tente novamente em 5 minutos!',
              'danger'
            );
          })
          .finally(() => this.$store.dispatch('endLoader'));
      }
    },
  },
};
</script>

<style>
@import '../../../custom/css/lista-dicas.css';
</style>
